import { CharityModel } from './CharityModel';
import { Type } from 'class-transformer';

export class DonationModel {
    @Type(() => CharityModel)
    public charities: CharityModel[] | null = null;
}